import { toastRef } from '../components/GlobalToast';

export const showSuccess = (message: string) => {
  toastRef.current?.show({
    severity: 'success',
    summary: message,
    life: 3000,
  });
};

export const showError = (message: string) => {
  toastRef.current?.show({
    severity: 'error',
    summary: message,
    life: 3000,
  });
};

export const showInfo = (message: string) => {
  toastRef.current?.show({
    severity: 'info',
    summary: message,
    life: 2500,
  });
};

export const showWarning = (message: string) => {
  toastRef.current?.show({
    severity: 'warn',
    summary: message,
    life: 3000,
  });
};
